// // import FurnitureNavbar from '../../../components/layout/Nav';
// import './admindashboard.scss';
// import { useEffect, useState } from 'react';
// import withAuth from '../../auth/WithAuth';
// import { serverUrlAuth } from '../../../serverUrl';
// import {
//   FaUsers,
//   FaProjectDiagram,
//   FaSpinner,
//   FaDollarSign,
//   FaHandshake,
//   FaFileAlt,
//   FaChartLine,
//   FaWallet,
//   FaStore,
//   FaCreditCard,
//   FaShoppingCart,
//   FaPercent,
//   FaMoneyBillWave,
//   FaTrophy,
// } from 'react-icons/fa';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   PointElement,
//   LineElement,
// } from 'chart.js';
// import { Bar, Doughnut, Line } from 'react-chartjs-2';
// import Sidebar from '../../../components/layout/Sidebar';

// // Register ChartJS components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   PointElement,
//   LineElement,
// );

// const AdminDashboard = () => {
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [lastUpdated, setLastUpdated] = useState(new Date());

//   const fetchDashboardData = async () => {
//     try {
//       const response = await serverUrlAuth.get('projects/admin/dashboard/');
//       setDashboardData(response.data);
//       setLastUpdated(new Date());
//     } catch (error) {
//       console.error('Error fetching admin dashboard:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchDashboardData();
//     const interval = setInterval(fetchDashboardData, 300000);
//     return () => clearInterval(interval);
//   }, []);

//   const formatCurrency = (amount) => {
//     return `KSh ${(amount || 0).toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//   };

//   if (loading) {
//     return (
//       <>
//         {/* <FurnitureNavbar /> */}
//         <Sidebar/>
//         <div className="admin-dashboard loading">
//           <div className="loading-container">
//             <FaSpinner className="spinner" />
//             <p>Loading dashboard...</p>
//           </div>
//         </div>
//       </>
//     );
//   }

//   const data = dashboardData || {};

//   // Chart: Revenue Overview (Bar Chart)
//   const revenueChartData = {
//     labels: ['Custom Projects', 'Ready-Made Shop', 'Total Platform Revenue'],
//     datasets: [
//       {
//         label: 'Revenue (KSh)',
//         data: [
//           data.revenue?.custom_projects?.total || 0,
//           data.revenue?.ready_made?.total || 0,
//           data.revenue?.platform?.total || 0,
//         ],
//         backgroundColor: [
//           'rgba(59, 130, 246, 0.8)',
//           'rgba(16, 185, 129, 0.8)',
//           'rgba(103, 50, 0, 0.8)',
//         ],
//         borderColor: ['#3b82f6', '#10b981', '#673200'],
//         borderWidth: 2,
//         borderRadius: 8,
//       },
//     ],
//   };

//   const revenueChartOptions = {
//     responsive: true,
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return `KSh ${context.parsed.y.toFixed(2)}`;
//           },
//         },
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           callback: function (value) {
//             return 'KSh ' + value.toFixed(2);
//           },
//         },
//       },
//     },
//   };

//   // Chart: Project Status Distribution (Doughnut)
//   const projectStatusData = {
//     labels: ['Open', 'In Progress', 'Awaiting Deposit', 'Completed'],
//     datasets: [
//       {
//         data: [
//           data.projects?.open || 0,
//           data.projects?.in_progress || 0,
//           data.projects?.awaiting_deposit || 0,
//           data.projects?.completed || 0,
//         ],
//         backgroundColor: [
//           'rgba(245, 158, 11, 0.8)',
//           'rgba(59, 130, 246, 0.8)',
//           'rgba(139, 92, 246, 0.8)',
//           'rgba(16, 185, 129, 0.8)',
//         ],
//         borderColor: ['#f59e0b', '#3b82f6', '#8b5cf6', '#10b981'],
//         borderWidth: 2,
//       },
//     ],
//   };

//   const doughnutOptions = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: 'bottom',
//         labels: {
//           padding: 20,
//           usePointStyle: true,
//           pointStyle: 'circle',
//         },
//       },
//     },
//     cutout: '65%',
//   };

//   // Chart: Monthly Revenue Trend (Line Chart)
//   const monthlyRevenueData = {
//     labels: data.monthly_revenue?.labels || [
//       'Jan',
//       'Feb',
//       'Mar',
//       'Apr',
//       'May',
//       'Jun',
//       'Jul',
//       'Aug',
//       'Sep',
//       'Oct',
//       'Nov',
//       'Dec',
//     ],
//     datasets: [
//       {
//         label: 'Total Revenue',
//         data: data.monthly_revenue?.total || Array(12).fill(0),
//         borderColor: '#673200',
//         backgroundColor: 'rgba(103, 50, 0, 0.1)',
//         fill: true,
//         tension: 0.4,
//         pointBackgroundColor: '#673200',
//         pointBorderColor: '#fff',
//         pointBorderWidth: 2,
//         pointRadius: 4,
//         pointHoverRadius: 6,
//       },
//       {
//         label: 'Custom Projects',
//         data: data.monthly_revenue?.custom_projects || Array(12).fill(0),
//         borderColor: '#3b82f6',
//         backgroundColor: 'rgba(59, 130, 246, 0.1)',
//         fill: true,
//         tension: 0.4,
//         pointBackgroundColor: '#3b82f6',
//         pointBorderColor: '#fff',
//         pointBorderWidth: 2,
//         pointRadius: 4,
//         pointHoverRadius: 6,
//       },
//       {
//         label: 'Ready-Made',
//         data: data.monthly_revenue?.ready_made || Array(12).fill(0),
//         borderColor: '#10b981',
//         backgroundColor: 'rgba(16, 185, 129, 0.1)',
//         fill: true,
//         tension: 0.4,
//         pointBackgroundColor: '#10b981',
//         pointBorderColor: '#fff',
//         pointBorderWidth: 2,
//         pointRadius: 4,
//         pointHoverRadius: 6,
//       },
//     ],
//   };

//   const lineOptions = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: 'top',
//         labels: {
//           usePointStyle: true,
//           padding: 20,
//           font: {
//             size: 11,
//           },
//         },
//       },
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return `${context.dataset.label}: KSh ${context.parsed.y.toFixed(2)}`;
//           },
//         },
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           callback: function (value) {
//             return 'KSh ' + value.toFixed(2);
//           },
//         },
//       },
//     },
//   };

//   // Payment Status Chart
//   const paymentStatusData = {
//     labels: ['Successful', 'Pending', 'Abandoned', 'Failed'],
//     datasets: [
//       {
//         data: [
//           data.payments?.summary?.successful || 0,
//           data.payments?.summary?.pending || 0,
//           data.payments?.summary?.abandoned || 0,
//           data.payments?.summary?.failed || 0,
//         ],
//         backgroundColor: [
//           'rgba(16, 185, 129, 0.8)',
//           'rgba(245, 158, 11, 0.8)',
//           'rgba(239, 68, 68, 0.8)',
//           'rgba(107, 114, 128, 0.8)',
//         ],
//         borderColor: ['#10b981', '#f59e0b', '#ef4444', '#6b7280'],
//         borderWidth: 2,
//       },
//     ],
//   };

//   const paymentDoughnutOptions = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: 'bottom',
//         labels: {
//           padding: 20,
//           usePointStyle: true,
//           pointStyle: 'circle',
//         },
//       },
//     },
//     cutout: '65%',
//   };

//   // Checkout Status Chart
//   const checkoutStatusData = {
//     labels: ['Paid', 'Pending Payment', 'Failed', 'Refunded'],
//     datasets: [
//       {
//         data: [
//           data.checkout?.summary?.paid || 0,
//           data.checkout?.summary?.pending_payment || 0,
//           data.checkout?.summary?.failed || 0,
//           data.checkout?.summary?.refunded || 0,
//         ],
//         backgroundColor: [
//           'rgba(16, 185, 129, 0.8)',
//           'rgba(245, 158, 11, 0.8)',
//           'rgba(239, 68, 68, 0.8)',
//           'rgba(107, 114, 128, 0.8)',
//         ],
//         borderColor: ['#10b981', '#f59e0b', '#ef4444', '#6b7280'],
//         borderWidth: 2,
//       },
//     ],
//   };

//   // =============================================================
//   // COMMISSION CHARTS
//   // =============================================================

//   // Commission Overview Bar Chart
//   const commissionChartData = {
//     labels: ['Custom Projects', 'Ready-Made', 'Total Commission'],
//     datasets: [
//       {
//         label: 'Commission (KSh)',
//         data: [
//           data.commissions?.custom_projects?.total_commission || 0,
//           data.commissions?.ready_made?.total_commission || 0,
//           data.commissions?.platform?.total_commission || 0,
//         ],
//         backgroundColor: [
//           'rgba(59, 130, 246, 0.8)',
//           'rgba(16, 185, 129, 0.8)',
//           'rgba(103, 50, 0, 0.8)',
//         ],
//         borderColor: ['#3b82f6', '#10b981', '#673200'],
//         borderWidth: 2,
//         borderRadius: 8,
//       },
//     ],
//   };

//   const commissionChartOptions = {
//     responsive: true,
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return `KSh ${context.parsed.y.toFixed(2)}`;
//           },
//         },
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           callback: function (value) {
//             return 'KSh ' + value.toFixed(2);
//           },
//         },
//       },
//     },
//   };

//   // Monthly Commission Trend Chart
//   const monthlyCommissionData = {
//     labels: data.commissions?.monthly_trend?.labels || [
//       'Jan',
//       'Feb',
//       'Mar',
//       'Apr',
//       'May',
//       'Jun',
//       'Jul',
//       'Aug',
//       'Sep',
//       'Oct',
//       'Nov',
//       'Dec',
//     ],
//     datasets: [
//       {
//         label: 'Total Commission',
//         data: data.commissions?.monthly_trend?.total || Array(12).fill(0),
//         borderColor: '#673200',
//         backgroundColor: 'rgba(103, 50, 0, 0.1)',
//         fill: true,
//         tension: 0.4,
//         pointBackgroundColor: '#673200',
//         pointBorderColor: '#fff',
//         pointBorderWidth: 2,
//         pointRadius: 4,
//         pointHoverRadius: 6,
//       },
//       {
//         label: 'Custom Projects',
//         data: data.commissions?.monthly_trend?.custom_projects || Array(12).fill(0),
//         borderColor: '#3b82f6',
//         backgroundColor: 'rgba(59, 130, 246, 0.1)',
//         fill: true,
//         tension: 0.4,
//         pointBackgroundColor: '#3b82f6',
//         pointBorderColor: '#fff',
//         pointBorderWidth: 2,
//         pointRadius: 4,
//         pointHoverRadius: 6,
//       },
//       {
//         label: 'Ready-Made',
//         data: data.commissions?.monthly_trend?.ready_made || Array(12).fill(0),
//         borderColor: '#10b981',
//         backgroundColor: 'rgba(16, 185, 129, 0.1)',
//         fill: true,
//         tension: 0.4,
//         pointBackgroundColor: '#10b981',
//         pointBorderColor: '#fff',
//         pointBorderWidth: 2,
//         pointRadius: 4,
//         pointHoverRadius: 6,
//       },
//     ],
//   };

//   const commissionLineOptions = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: 'top',
//         labels: {
//           usePointStyle: true,
//           padding: 20,
//           font: {
//             size: 11,
//           },
//         },
//       },
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return `${context.dataset.label}: KSh ${context.parsed.y.toFixed(2)}`;
//           },
//         },
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           callback: function (value) {
//             return 'KSh ' + value.toFixed(2);
//           },
//         },
//       },
//     },
//   };

//   // Commission Status Doughnut - Custom Projects
//   const customCommissionStatusData = {
//     labels: data.commissions?.custom_projects?.by_status?.map(item => 
//       item.status.charAt(0).toUpperCase() + item.status.slice(1).replace('_', ' ')
//     ) || ['Pending', 'Partially Paid', 'Paid'],
//     datasets: [
//       {
//         data: data.commissions?.custom_projects?.by_status?.map(item => 
//           parseFloat(item.total_commission)
//         ) || [0, 0, 0],
//         backgroundColor: [
//           'rgba(245, 158, 11, 0.8)',
//           'rgba(59, 130, 246, 0.8)',
//           'rgba(16, 185, 129, 0.8)',
//         ],
//         borderColor: ['#f59e0b', '#3b82f6', '#10b981'],
//         borderWidth: 2,
//       },
//     ],
//   };

//   // Commission Status Doughnut - Ready-Made
//   const readyMadeCommissionStatusData = {
//     labels: data.commissions?.ready_made?.by_status?.map(item => 
//       item.status.charAt(0).toUpperCase() + item.status.slice(1).replace('_', ' ')
//     ) || ['Pending', 'Partially Paid', 'Paid'],
//     datasets: [
//       {
//         data: data.commissions?.ready_made?.by_status?.map(item => 
//           parseFloat(item.total_commission)
//         ) || [0, 0, 0],
//         backgroundColor: [
//           'rgba(245, 158, 11, 0.8)',
//           'rgba(59, 130, 246, 0.8)',
//           'rgba(16, 185, 129, 0.8)',
//         ],
//         borderColor: ['#f59e0b', '#3b82f6', '#10b981'],
//         borderWidth: 2,
//       },
//     ],
//   };

//   const commissionDoughnutOptions = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: 'bottom',
//         labels: {
//           padding: 20,
//           usePointStyle: true,
//           pointStyle: 'circle',
//         },
//       },
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return `${context.label}: KSh ${context.parsed.toFixed(2)}`;
//           },
//         },
//       },
//     },
//     cutout: '65%',
//   };

//   // Payment Type Breakdown Chart
//   const paymentTypeData = {
//     labels: ['Deposit', 'Balance'],
//     datasets: [
//       {
//         label: 'Number of Payments',
//         data: [
//           data.payments?.payment_type_breakdown?.deposit || 0,
//           data.payments?.payment_type_breakdown?.balance || 0,
//         ],
//         backgroundColor: ['rgba(59, 130, 246, 0.8)', 'rgba(16, 185, 129, 0.8)'],
//         borderColor: ['#3b82f6', '#10b981'],
//         borderWidth: 2,
//         borderRadius: 8,
//       },
//     ],
//   };

//   const paymentTypeOptions = {
//     responsive: true,
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return `${context.parsed.y} payments`;
//           },
//         },
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           stepSize: 1,
//         },
//       },
//     },
//   };

//   // Top stats for quick view
//   const topStats = [
//     {
//       icon: FaUsers,
//       label: 'Total Users',
//       value: data.users?.total || 0,
//       subtitle: `${data.users?.new_today || 0} new today`,
//       color: '#3b82f6',
//       bg: 'rgba(59, 130, 246, 0.1)',
//     },
//     {
//       icon: FaProjectDiagram,
//       label: 'Total Projects',
//       value: data.projects?.total || 0,
//       subtitle: `${data.projects?.new_this_month || 0} this month`,
//       color: '#10b981',
//       bg: 'rgba(16, 185, 129, 0.1)',
//     },
//     {
//       icon: FaDollarSign,
//       label: 'Total Revenue',
//       value: formatCurrency(data.revenue?.platform?.total || 0),
//       subtitle: formatCurrency(data.revenue?.platform?.today || 0) + ' today',
//       color: '#f59e0b',
//       bg: 'rgba(245, 158, 11, 0.1)',
//     },
//     {
//       icon: FaStore,
//       label: 'Total Orders',
//       value: data.checkout?.summary?.total_orders || 0,
//       subtitle: `${data.checkout?.summary?.new_today || 0} new today`,
//       color: '#8b5cf6',
//       bg: 'rgba(139, 92, 246, 0.1)',
//     },
//     {
//       icon: FaHandshake,
//       label: 'Negotiations',
//       value: data.negotiations?.total || 0,
//       subtitle: `${data.negotiations?.open || 0} open`,
//       color: '#ec4899',
//       bg: 'rgba(236, 72, 153, 0.1)',
//     },
//     {
//       icon: FaFileAlt,
//       label: 'Proposals',
//       value: data.proposals?.total || 0,
//       subtitle: `${data.proposals?.selected || 0} selected`,
//       color: '#14b8a6',
//       bg: 'rgba(20, 184, 166, 0.1)',
//     },
//   ];

//   // Commission quick metrics
//   const commissionMetrics = [
//     {
//       icon: FaMoneyBillWave,
//       label: 'Total Commission',
//       value: formatCurrency(data.commissions?.platform?.total_commission || 0),
//       sub: formatCurrency(data.commissions?.platform?.monthly || 0) + ' this month',
//       color: '#673200',
//     },
//     {
//       icon: FaPercent,
//       label: 'Avg Commission Rate',
//       value: `${data.commissions?.custom_projects?.average_rate || 0}%`,
//       sub: 'Custom projects',
//       color: '#3b82f6',
//     },
//     {
//       icon: FaPercent,
//       label: 'Avg Commission Rate',
//       value: `${data.commissions?.ready_made?.average_rate || 0}%`,
//       sub: 'Ready-made orders',
//       color: '#10b981',
//     },
//     {
//       icon: FaTrophy,
//       label: 'Top Artisan Commission',
//       value: formatCurrency(data.commissions?.custom_projects?.top_artisans?.[0]?.total_commission || 0),
//       sub: data.commissions?.custom_projects?.top_artisans?.[0]?.artisan__full_name || 'N/A',
//       color: '#f59e0b',
//     },
//   ];

//   const paymentTypeBreakdown = data.payments?.payment_type_breakdown || {};
//   const hasPaymentData = Object.keys(paymentTypeBreakdown).length > 0;

//   return (
//     <>
//       {/* <FurnitureNavbar /> */}
//       <Sidebar />
//       <div className="admin-dashboard">
//         {/* Header */}
//         <header className="admin-header">
//           <div className="container">
//             <div className="header-content">
//               <div className="header-text">
//                 <h1>
//                   <span className="header-icon">📊</span> Admin Dashboard
//                 </h1>
//                 <p>Monitor platform performance and manage your marketplace</p>
//               </div>
//             </div>
//           </div>
//         </header>

//         <div className="container">
//           {/* Quick Stats Row */}
//           <div className="quick-stats">
//             {topStats.map((stat, index) => {
//               const Icon = stat.icon;
//               return (
//                 <div key={index} className="quick-stat">
//                   <div
//                     className="quick-stat-icon"
//                     style={{ background: stat.bg, color: stat.color }}
//                   >
//                     <Icon />
//                   </div>
//                   <div className="quick-stat-info">
//                     <span className="quick-stat-label">{stat.label}</span>
//                     <span className="quick-stat-value">{stat.value}</span>
//                     {stat.subtitle && (
//                       <span className="quick-stat-subtitle">
//                         {stat.subtitle}
//                       </span>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* ============================================================= */}
//           {/* COMMISSIONS SECTION - NEW */}
//           {/* ============================================================= */}
//           <div className="commissions-section">
//             <div className="section-header">
//               <h2>
//                 <FaPercent className="section-icon" /> Commission Overview
//               </h2>
//               <span className="status-indicator online">
//                 {formatCurrency(data.commissions?.platform?.total_commission || 0)} total
//               </span>
//             </div>

//             {/* Commission Quick Stats */}
//             <div className="commission-metrics-grid">
//               {commissionMetrics.map((metric, index) => {
//                 const Icon = metric.icon;
//                 return (
//                   <div key={index} className="commission-metric">
//                     <div
//                       className="commission-metric-icon"
//                       style={{ background: `rgba(103, 50, 0, 0.08)`, color: metric.color }}
//                     >
//                       <Icon />
//                     </div>
//                     <div className="commission-metric-info">
//                       <span className="commission-metric-label">{metric.label}</span>
//                       <span className="commission-metric-value">{metric.value}</span>
//                       {metric.sub && (
//                         <span className="commission-metric-sub">{metric.sub}</span>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             {/* Commission Charts Row */}
//             <div className="charts-row">
//               {/* Commission Overview Bar Chart */}
//               <div className="chart-card revenue-chart">
//                 <div className="chart-header">
//                   <h3>
//                     <FaMoneyBillWave className="chart-icon" /> Commission Breakdown
//                   </h3>
//                   <span className="chart-subtitle">Artiza's earnings from commissions</span>
//                 </div>
//                 <div className="chart-container">
//                   <Bar data={commissionChartData} options={commissionChartOptions} />
//                 </div>
//               </div>

//               {/* Commission Trend Line Chart */}
//               <div className="chart-card trend-chart">
//                 <div className="chart-header">
//                   <h3>
//                     <FaChartLine className="chart-icon" /> Monthly Commission Trend
//                   </h3>
//                   <span className="chart-subtitle">Commission growth over time</span>
//                 </div>
//                 <div className="chart-container">
//                   <Line data={monthlyCommissionData} options={commissionLineOptions} />
//                 </div>
//               </div>
//             </div>

//             {/* Commission Status Charts */}
//             <div className="charts-row">
//               <div className="chart-card status-chart">
//                 <div className="chart-header">
//                   <h3>
//                     <FaProjectDiagram className="chart-icon" /> Custom Projects Commission
//                   </h3>
//                   <span className="chart-subtitle">
//                     Total: {formatCurrency(data.commissions?.custom_projects?.total_commission || 0)}
//                   </span>
//                 </div>
//                 <div className="chart-container doughnut-container">
//                   <Doughnut data={customCommissionStatusData} options={commissionDoughnutOptions} />
//                 </div>
//               </div>

//               <div className="chart-card status-chart">
//                 <div className="chart-header">
//                   <h3>
//                     <FaStore className="chart-icon" /> Ready-Made Commission
//                   </h3>
//                   <span className="chart-subtitle">
//                     Total: {formatCurrency(data.commissions?.ready_made?.total_commission || 0)}
//                   </span>
//                 </div>
//                 <div className="chart-container doughnut-container">
//                   <Doughnut data={readyMadeCommissionStatusData} options={commissionDoughnutOptions} />
//                 </div>
//               </div>
//             </div>

//             {/* Top Artisans by Commission */}
//             {data.commissions?.custom_projects?.top_artisans?.length > 0 && (
//               <div className="top-commission-artisans">
//                 <div className="section-header">
//                   <h3>
//                     <FaTrophy className="section-icon" /> Top Artisans by Commission
//                   </h3>
//                 </div>
//                 <div className="artisans-list">
//                   {data.commissions.custom_projects.top_artisans.slice(0, 5).map((artisan, index) => (
//                     <div key={index} className="artisan-item">
//                       <div className="artisan-rank">{index + 1}</div>
//                       <div className="artisan-avatar">
//                         {artisan.artisan__full_name?.charAt(0) || 'A'}
//                       </div>
//                       <div className="artisan-info">
//                         <h4>{artisan.artisan__full_name || 'Unknown'}</h4>
//                         <p>{artisan.artisan__email}</p>
//                       </div>
//                       <div className="artisan-stats">
//                         <span className="stat-badge">
//                           {artisan.count} projects
//                         </span>
//                       </div>
//                       <div className="artisan-rate">
//                         <span className="rate-value">
//                           {formatCurrency(artisan.total_commission)}
//                         </span>
//                         <span className="rate-label">commission</span>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Revenue Overview Cards */}
//           <div className="revenue-overview-cards">
//             <div className="revenue-card custom">
//               <div className="revenue-card-icon">
//                 <FaProjectDiagram />
//               </div>
//               <div className="revenue-card-info">
//                 <span className="revenue-card-label">
//                   Custom Projects Revenue
//                 </span>
//                 <span className="revenue-card-value">
//                   {formatCurrency(data.revenue?.custom_projects?.total || 0)}
//                 </span>
//                 <span className="revenue-card-sub">
//                   {formatCurrency(data.revenue?.custom_projects?.monthly || 0)}{' '}
//                   this month
//                 </span>
//               </div>
//             </div>
//             <div className="revenue-card ready">
//               <div className="revenue-card-icon">
//                 <FaStore />
//               </div>
//               <div className="revenue-card-info">
//                 <span className="revenue-card-label">Ready-Made Revenue</span>
//                 <span className="revenue-card-value">
//                   {formatCurrency(data.revenue?.ready_made?.total || 0)}
//                 </span>
//                 <span className="revenue-card-sub">
//                   {formatCurrency(data.revenue?.ready_made?.monthly || 0)} this
//                   month
//                 </span>
//               </div>
//             </div>
//             <div className="revenue-card total">
//               <div className="revenue-card-icon">
//                 <FaDollarSign />
//               </div>
//               <div className="revenue-card-info">
//                 <span className="revenue-card-label">
//                   Total Platform Revenue
//                 </span>
//                 <span className="revenue-card-value">
//                   {formatCurrency(data.revenue?.platform?.total || 0)}
//                 </span>
//                 <span className="revenue-card-sub">
//                   {formatCurrency(data.revenue?.platform?.today || 0)} today
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Charts Row */}
//           <div className="charts-row">
//             {/* Revenue Chart */}
//             <div className="chart-card revenue-chart">
//               <div className="chart-header">
//                 <h3>
//                   <FaDollarSign className="chart-icon" /> Revenue Overview
//                 </h3>
//                 <span className="chart-subtitle">
//                   Total platform revenue breakdown
//                 </span>
//               </div>
//               <div className="chart-container">
//                 <Bar data={revenueChartData} options={revenueChartOptions} />
//               </div>
//             </div>

//             {/* Project Status Chart */}
//             <div className="chart-card status-chart">
//               <div className="chart-header">
//                 <h3>
//                   <FaProjectDiagram className="chart-icon" /> Project Status
//                 </h3>
//                 <span className="chart-subtitle">Distribution by status</span>
//               </div>
//               <div className="chart-container doughnut-container">
//                 <Doughnut data={projectStatusData} options={doughnutOptions} />
//               </div>
//             </div>
//           </div>

//           {/* Second Row of Charts */}
//           <div className="charts-row">
//             {/* Monthly Revenue Trend */}
//             <div className="chart-card trend-chart">
//               <div className="chart-header">
//                 <h3>
//                   <FaChartLine className="chart-icon" /> Monthly Revenue Trend
//                 </h3>
//                 <span className="chart-subtitle">
//                   Revenue performance over time
//                 </span>
//               </div>
//               <div className="chart-container">
//                 <Line data={monthlyRevenueData} options={lineOptions} />
//               </div>
//             </div>

//             {/* Payment Type Breakdown Chart */}
//             {hasPaymentData && (
//               <div className="chart-card payment-type-chart">
//                 <div className="chart-header">
//                   <h3>
//                     <FaCreditCard className="chart-icon" /> Payment Type
//                     Breakdown
//                   </h3>
//                   <span className="chart-subtitle">
//                     Deposit vs Balance payments
//                   </span>
//                 </div>
//                 <div className="chart-container">
//                   <Bar data={paymentTypeData} options={paymentTypeOptions} />
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Third Row of Charts */}
//           <div className="charts-row">
//             {/* Checkout Status Chart */}
//             <div className="chart-card status-chart">
//               <div className="chart-header">
//                 <h3>
//                   <FaShoppingCart className="chart-icon" /> Checkout Status
//                 </h3>
//                 <span className="chart-subtitle">Ready-made order status</span>
//               </div>
//               <div className="chart-container doughnut-container">
//                 <Doughnut
//                   data={checkoutStatusData}
//                   options={paymentDoughnutOptions}
//                 />
//               </div>
//             </div>

//             {/* Payment Status Chart */}
//             <div className="chart-card status-chart">
//               <div className="chart-header">
//                 <h3>
//                   <FaWallet className="chart-icon" /> Payment Status
//                 </h3>
//                 <span className="chart-subtitle">
//                   Custom projects payment status
//                 </span>
//               </div>
//               <div className="chart-container doughnut-container">
//                 <Doughnut
//                   data={paymentStatusData}
//                   options={paymentDoughnutOptions}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default withAuth(AdminDashboard, 'admin');



// src/pages/admin/AdminDashboard.jsx
import './admindashboard.scss';
import { useEffect, useState, useRef } from 'react';
import withAuth from '../../auth/WithAuth';
import { serverUrlAuth } from '../../../serverUrl';
import {
  FaUsers,
  FaProjectDiagram,
  FaSpinner,
  FaDollarSign,
  FaHandshake,
  FaFileAlt,
  FaChartLine,
  FaWallet,
  FaStore,
  FaCreditCard,
  FaShoppingCart,
  FaPercent,
  FaMoneyBillWave,
  FaTrophy,
  FaSyncAlt,
  FaClock,
  FaArrowUp,
  FaArrowRight,
  FaBolt,
  FaLayerGroup,
  FaBell,
} from 'react-icons/fa';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  PointElement,
  LineElement,
  Filler,
} from 'chart.js';
import { Bar, Doughnut, Line } from 'react-chartjs-2';
import Sidebar from '../../../components/layout/Sidebar';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  PointElement,
  LineElement,
  Filler,
);

// ---------- Animated number hook (visual only) ----------
function useCountUp(target, duration = 900) {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const end = Number(target) || 0;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setValue(end * eased);
      if (p < 1) ref.current = requestAnimationFrame(tick);
    };
    ref.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(ref.current);
  }, [target, duration]);
  return value;
}

const AdminDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const [activeSection, setActiveSection] = useState('overview');

  const fetchDashboardData = async (isRefresh = false) => {
    if (isRefresh) setRefreshing(true);
    try {
      const response = await serverUrlAuth.get('projects/admin/dashboard/');
      setDashboardData(response.data);
      setLastUpdated(new Date());
    } catch (error) {
      console.error('Error fetching admin dashboard:', error);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
    const interval = setInterval(() => fetchDashboardData(), 300000);
    return () => clearInterval(interval);
  }, []);

  const formatCurrency = (amount) => {
    return `KSh ${(amount || 0).toLocaleString('en-KE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  if (loading) {
    return (
      <>
        <Sidebar />
        <div className="admin-dashboard loading">
          <div className="loading-container">
            <div className="orbit-spinner">
              <div></div>
              <div></div>
              <div></div>
            </div>
            <p>Loading…</p>
          </div>
        </div>
      </>
    );
  }

  const data = dashboardData || {};

  // ============================================================
  // CHART DATA — UNCHANGED (values, labels, sources identical)
  // ============================================================

  const revenueChartData = {
    labels: ['Custom Projects', 'Ready-Made Shop', 'Total Platform Revenue'],
    datasets: [
      {
        label: 'Revenue (KSh)',
        data: [
          data.revenue?.custom_projects?.total || 0,
          data.revenue?.ready_made?.total || 0,
          data.revenue?.platform?.total || 0,
        ],
        backgroundColor: [
          'rgba(59, 130, 246, 0.85)',
          'rgba(16, 185, 129, 0.85)',
          'rgba(103, 50, 0, 0.9)',
        ],
        borderColor: ['#3b82f6', '#10b981', '#673200'],
        borderWidth: 0,
        borderRadius: 10,
        maxBarThickness: 64,
      },
    ],
  };

  const revenueChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: '#1a1008',
        padding: 12,
        cornerRadius: 8,
        titleFont: { size: 12, weight: 600 },
        bodyFont: { size: 12 },
        callbacks: { label: (ctx) => `KSh ${ctx.parsed.y.toFixed(2)}` },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: '#6f6a66', font: { size: 11, weight: 500 } },
      },
      y: {
        beginAtZero: true,
        grid: { color: 'rgba(103, 50, 0, 0.05)', drawBorder: false },
        ticks: {
          color: '#6f6a66',
          font: { size: 11 },
          callback: (v) =>
            v >= 1000 ? `${(v / 1000).toFixed(0)}K` : v,
        },
      },
    },
  };

  const projectStatusData = {
    labels: ['Open', 'In Progress', 'Awaiting Deposit', 'Completed'],
    datasets: [
      {
        data: [
          data.projects?.open || 0,
          data.projects?.in_progress || 0,
          data.projects?.awaiting_deposit || 0,
          data.projects?.completed || 0,
        ],
        backgroundColor: ['#f59e0b', '#3b82f6', '#8b5cf6', '#10b981'],
        borderColor: '#fff',
        borderWidth: 3,
        hoverOffset: 8,
      },
    ],
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          padding: 14,
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 8,
          font: { size: 11, weight: 500 },
          color: '#1a1008',
        },
      },
      tooltip: { backgroundColor: '#1a1008', padding: 10, cornerRadius: 8 },
    },
    cutout: '70%',
  };

  const monthlyRevenueData = {
    labels: data.monthly_revenue?.labels || [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    ],
    datasets: [
      {
        label: 'Total Revenue',
        data: data.monthly_revenue?.total || Array(12).fill(0),
        borderColor: '#673200',
        backgroundColor: 'rgba(103, 50, 0, 0.12)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#673200',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 6,
        borderWidth: 2,
      },
      {
        label: 'Custom Projects',
        data: data.monthly_revenue?.custom_projects || Array(12).fill(0),
        borderColor: '#3b82f6',
        backgroundColor: 'rgba(59, 130, 246, 0.08)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#3b82f6',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 6,
        borderWidth: 2,
      },
      {
        label: 'Ready-Made',
        data: data.monthly_revenue?.ready_made || Array(12).fill(0),
        borderColor: '#10b981',
        backgroundColor: 'rgba(16, 185, 129, 0.08)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#10b981',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 6,
        borderWidth: 2,
      },
    ],
  };

  const lineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        align: 'end',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          padding: 16,
          boxWidth: 8,
          font: { size: 11, weight: 500 },
          color: '#1a1008',
        },
      },
      tooltip: {
        backgroundColor: '#1a1008',
        padding: 12,
        cornerRadius: 8,
        callbacks: {
          label: (ctx) =>
            `${ctx.dataset.label}: KSh ${ctx.parsed.y.toFixed(2)}`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: '#6f6a66', font: { size: 11 } },
      },
      y: {
        beginAtZero: true,
        grid: { color: 'rgba(103, 50, 0, 0.05)', drawBorder: false },
        ticks: {
          color: '#6f6a66',
          font: { size: 11 },
          callback: (v) =>
            v >= 1000 ? `${(v / 1000).toFixed(0)}K` : v,
        },
      },
    },
  };

  const paymentStatusData = {
    labels: ['Successful', 'Pending', 'Abandoned', 'Failed'],
    datasets: [
      {
        data: [
          data.payments?.summary?.successful || 0,
          data.payments?.summary?.pending || 0,
          data.payments?.summary?.abandoned || 0,
          data.payments?.summary?.failed || 0,
        ],
        backgroundColor: ['#10b981', '#f59e0b', '#ef4444', '#6b7280'],
        borderColor: '#fff',
        borderWidth: 3,
        hoverOffset: 8,
      },
    ],
  };

  const paymentDoughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          padding: 14,
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 8,
          font: { size: 11, weight: 500 },
          color: '#1a1008',
        },
      },
      tooltip: { backgroundColor: '#1a1008', padding: 10, cornerRadius: 8 },
    },
    cutout: '70%',
  };

  const checkoutStatusData = {
    labels: ['Paid', 'Pending Payment', 'Failed', 'Refunded'],
    datasets: [
      {
        data: [
          data.checkout?.summary?.paid || 0,
          data.checkout?.summary?.pending_payment || 0,
          data.checkout?.summary?.failed || 0,
          data.checkout?.summary?.refunded || 0,
        ],
        backgroundColor: ['#10b981', '#f59e0b', '#ef4444', '#6b7280'],
        borderColor: '#fff',
        borderWidth: 3,
        hoverOffset: 8,
      },
    ],
  };

  const commissionChartData = {
    labels: ['Custom Projects', 'Ready-Made', 'Total Commission'],
    datasets: [
      {
        label: 'Commission (KSh)',
        data: [
          data.commissions?.custom_projects?.total_commission || 0,
          data.commissions?.ready_made?.total_commission || 0,
          data.commissions?.platform?.total_commission || 0,
        ],
        backgroundColor: [
          'rgba(59, 130, 246, 0.85)',
          'rgba(16, 185, 129, 0.85)',
          'rgba(103, 50, 0, 0.9)',
        ],
        borderColor: ['#3b82f6', '#10b981', '#673200'],
        borderWidth: 0,
        borderRadius: 10,
        maxBarThickness: 64,
      },
    ],
  };

  const commissionChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: '#1a1008',
        padding: 12,
        cornerRadius: 8,
        callbacks: { label: (ctx) => `KSh ${ctx.parsed.y.toFixed(2)}` },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: '#6f6a66', font: { size: 11, weight: 500 } },
      },
      y: {
        beginAtZero: true,
        grid: { color: 'rgba(103, 50, 0, 0.05)', drawBorder: false },
        ticks: {
          color: '#6f6a66',
          font: { size: 11 },
          callback: (v) =>
            v >= 1000 ? `${(v / 1000).toFixed(0)}K` : v,
        },
      },
    },
  };

  const monthlyCommissionData = {
    labels: data.commissions?.monthly_trend?.labels || [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    ],
    datasets: [
      {
        label: 'Total Commission',
        data: data.commissions?.monthly_trend?.total || Array(12).fill(0),
        borderColor: '#673200',
        backgroundColor: 'rgba(103, 50, 0, 0.12)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#673200',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 6,
        borderWidth: 2,
      },
      {
        label: 'Custom Projects',
        data:
          data.commissions?.monthly_trend?.custom_projects ||
          Array(12).fill(0),
        borderColor: '#3b82f6',
        backgroundColor: 'rgba(59, 130, 246, 0.08)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#3b82f6',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 6,
        borderWidth: 2,
      },
      {
        label: 'Ready-Made',
        data:
          data.commissions?.monthly_trend?.ready_made || Array(12).fill(0),
        borderColor: '#10b981',
        backgroundColor: 'rgba(16, 185, 129, 0.08)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#10b981',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 6,
        borderWidth: 2,
      },
    ],
  };

  const commissionLineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        align: 'end',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          padding: 16,
          boxWidth: 8,
          font: { size: 11, weight: 500 },
          color: '#1a1008',
        },
      },
      tooltip: {
        backgroundColor: '#1a1008',
        padding: 12,
        cornerRadius: 8,
        callbacks: {
          label: (ctx) =>
            `${ctx.dataset.label}: KSh ${ctx.parsed.y.toFixed(2)}`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: '#6f6a66', font: { size: 11 } },
      },
      y: {
        beginAtZero: true,
        grid: { color: 'rgba(103, 50, 0, 0.05)', drawBorder: false },
        ticks: {
          color: '#6f6a66',
          font: { size: 11 },
          callback: (v) =>
            v >= 1000 ? `${(v / 1000).toFixed(0)}K` : v,
        },
      },
    },
  };

  const customCommissionStatusData = {
    labels:
      data.commissions?.custom_projects?.by_status?.map(
        (item) =>
          item.status.charAt(0).toUpperCase() +
          item.status.slice(1).replace('_', ' '),
      ) || ['Pending', 'Partially Paid', 'Paid'],
    datasets: [
      {
        data:
          data.commissions?.custom_projects?.by_status?.map((item) =>
            parseFloat(item.total_commission),
          ) || [0, 0, 0],
        backgroundColor: ['#f59e0b', '#3b82f6', '#10b981'],
        borderColor: '#fff',
        borderWidth: 3,
        hoverOffset: 8,
      },
    ],
  };

  const readyMadeCommissionStatusData = {
    labels:
      data.commissions?.ready_made?.by_status?.map(
        (item) =>
          item.status.charAt(0).toUpperCase() +
          item.status.slice(1).replace('_', ' '),
      ) || ['Pending', 'Partially Paid', 'Paid'],
    datasets: [
      {
        data:
          data.commissions?.ready_made?.by_status?.map((item) =>
            parseFloat(item.total_commission),
          ) || [0, 0, 0],
        backgroundColor: ['#f59e0b', '#3b82f6', '#10b981'],
        borderColor: '#fff',
        borderWidth: 3,
        hoverOffset: 8,
      },
    ],
  };

  const commissionDoughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          padding: 14,
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 8,
          font: { size: 11, weight: 500 },
          color: '#1a1008',
        },
      },
      tooltip: {
        backgroundColor: '#1a1008',
        padding: 10,
        cornerRadius: 8,
        callbacks: {
          label: (ctx) => `${ctx.label}: KSh ${ctx.parsed.toFixed(2)}`,
        },
      },
    },
    cutout: '70%',
  };

  const paymentTypeData = {
    labels: ['Deposit', 'Balance'],
    datasets: [
      {
        label: 'Number of Payments',
        data: [
          data.payments?.payment_type_breakdown?.deposit || 0,
          data.payments?.payment_type_breakdown?.balance || 0,
        ],
        backgroundColor: [
          'rgba(59, 130, 246, 0.85)',
          'rgba(16, 185, 129, 0.85)',
        ],
        borderWidth: 0,
        borderRadius: 10,
        maxBarThickness: 80,
      },
    ],
  };

  const paymentTypeOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: '#1a1008',
        padding: 10,
        cornerRadius: 8,
        callbacks: { label: (ctx) => `${ctx.parsed.y} payments` },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: '#6f6a66', font: { size: 11 } },
      },
      y: {
        beginAtZero: true,
        grid: { color: 'rgba(103, 50, 0, 0.05)', drawBorder: false },
        ticks: { color: '#6f6a66', stepSize: 1 },
      },
    },
  };

  // ------------------------------------------------------------
  // Hero stats (values unchanged)
  // ------------------------------------------------------------
  const heroStats = [
    {
      key: 'revenue',
      icon: <FaDollarSign />,
      label: 'Total Revenue',
      raw: data.revenue?.platform?.total || 0,
      value: formatCurrency(data.revenue?.platform?.total || 0),
      sub: `${formatCurrency(data.revenue?.platform?.today || 0)} today`,
      accent: 'gold',
    },
    {
      key: 'users',
      icon: <FaUsers />,
      label: 'Total Users',
      raw: data.users?.total || 0,
      value: (data.users?.total || 0).toLocaleString(),
      sub: `${data.users?.new_today || 0} new today`,
      accent: 'blue',
    },
    {
      key: 'projects',
      icon: <FaProjectDiagram />,
      label: 'Total Projects',
      raw: data.projects?.total || 0,
      value: (data.projects?.total || 0).toLocaleString(),
      sub: `${data.projects?.new_this_month || 0} this month`,
      accent: 'violet',
    },
    {
      key: 'orders',
      icon: <FaStore />,
      label: 'Total Orders',
      raw: data.checkout?.summary?.total_orders || 0,
      value: (data.checkout?.summary?.total_orders || 0).toLocaleString(),
      sub: `${data.checkout?.summary?.new_today || 0} new today`,
      accent: 'emerald',
    },
  ];

  // Secondary stats — UNCHANGED values
  const topStats = [
    {
      icon: FaUsers,
      label: 'Total Users',
      value: data.users?.total || 0,
      subtitle: `${data.users?.new_today || 0} new today`,
      color: '#3b82f6',
      bg: 'rgba(59, 130, 246, 0.1)',
    },
    {
      icon: FaProjectDiagram,
      label: 'Total Projects',
      value: data.projects?.total || 0,
      subtitle: `${data.projects?.new_this_month || 0} this month`,
      color: '#10b981',
      bg: 'rgba(16, 185, 129, 0.1)',
    },
    {
      icon: FaDollarSign,
      label: 'Total Revenue',
      value: formatCurrency(data.revenue?.platform?.total || 0),
      subtitle: formatCurrency(data.revenue?.platform?.today || 0) + ' today',
      color: '#f59e0b',
      bg: 'rgba(245, 158, 11, 0.1)',
    },
    {
      icon: FaStore,
      label: 'Total Orders',
      value: data.checkout?.summary?.total_orders || 0,
      subtitle: `${data.checkout?.summary?.new_today || 0} new today`,
      color: '#8b5cf6',
      bg: 'rgba(139, 92, 246, 0.1)',
    },
    {
      icon: FaHandshake,
      label: 'Negotiations',
      value: data.negotiations?.total || 0,
      subtitle: `${data.negotiations?.open || 0} open`,
      color: '#ec4899',
      bg: 'rgba(236, 72, 153, 0.1)',
    },
    {
      icon: FaFileAlt,
      label: 'Proposals',
      value: data.proposals?.total || 0,
      subtitle: `${data.proposals?.selected || 0} selected`,
      color: '#14b8a6',
      bg: 'rgba(20, 184, 166, 0.1)',
    },
  ];

  // Commission metrics — UNCHANGED values
  const commissionMetrics = [
    {
      icon: FaMoneyBillWave,
      label: 'Total Commission',
      value: formatCurrency(data.commissions?.platform?.total_commission || 0),
      sub:
        formatCurrency(data.commissions?.platform?.monthly || 0) +
        ' this month',
      color: '#673200',
    },
    {
      icon: FaPercent,
      label: 'Avg Commission Rate',
      value: `${data.commissions?.custom_projects?.average_rate || 0}%`,
      sub: 'Custom projects',
      color: '#3b82f6',
    },
    {
      icon: FaPercent,
      label: 'Avg Commission Rate',
      value: `${data.commissions?.ready_made?.average_rate || 0}%`,
      sub: 'Ready-made orders',
      color: '#10b981',
    },
    {
      icon: FaTrophy,
      label: 'Top Artisan Commission',
      value: formatCurrency(
        data.commissions?.custom_projects?.top_artisans?.[0]
          ?.total_commission || 0,
      ),
      sub:
        data.commissions?.custom_projects?.top_artisans?.[0]
          ?.artisan__full_name || 'N/A',
      color: '#f59e0b',
    },
  ];

  const paymentTypeBreakdown = data.payments?.payment_type_breakdown || {};
  const hasPaymentData = Object.keys(paymentTypeBreakdown).length > 0;

  const sections = [
    { key: 'overview', label: 'Overview', icon: <FaLayerGroup /> },
    { key: 'commissions', label: 'Commissions', icon: <FaPercent /> },
    { key: 'revenue', label: 'Revenue', icon: <FaDollarSign /> },
    { key: 'payments', label: 'Payments', icon: <FaWallet /> },
  ];

  // ------------------------------------------------------------
  // Hero KPI Card with animated counter
  // ------------------------------------------------------------
  const HeroKpi = ({ stat }) => {
    const animated = useCountUp(stat.raw);
    const isCurrency = stat.key === 'revenue';
    const display = isCurrency
      ? formatCurrency(animated)
      : Math.round(animated).toLocaleString();
    return (
      <div className={`hero-kpi accent-${stat.accent}`}>
        <div className="hero-kpi-glow" />
        <div className="hero-kpi-top">
          <div className="hero-kpi-icon">{stat.icon}</div>
          
        </div>
        <div className="hero-kpi-label">{stat.label}</div>
        <div className="hero-kpi-value">{display}</div>
        <div className="hero-kpi-sub">{stat.sub}</div>
        <div className="hero-kpi-bar" />
      </div>
    );
  };

  return (
    <>
      <Sidebar />
      <div className="admin-dashboard">
       

        {/* ============ HERO ============ */}
        <section className="hero">
          <div className="hero-bg">
            <div className="hero-orb orb-1" />
            <div className="hero-orb orb-2" />
            <div className="hero-grid" />
          </div>
          <div className="hero-content">
            <div className="hero-text">
              <span className="hero-eyebrow">ADMIN · ARTIZA PLATFORM</span>
              <h1>
                Welcome back, <span className="accent">Admin</span>
              </h1>
              <p>
                Your marketplace at a glance — revenue, projects, and
                commissions, all in real time.
              </p>
            </div>
           
          </div>

          {/* HERO KPI GRID */}
          <div className="hero-kpi-grid">
            {heroStats.map((stat) => (
              <HeroKpi key={stat.key} stat={stat} />
            ))}
          </div>
        </section>

        {/* ============ SEGMENTED NAV ============ */}
        <div className="segment-nav">
          {sections.map((s) => (
            <button
              key={s.key}
              className={`segment ${activeSection === s.key ? 'active' : ''}`}
              onClick={() => setActiveSection(s.key)}
            >
              {s.icon}
              <span>{s.label}</span>
            </button>
          ))}
        </div>

        {/* ============ OVERVIEW ============ */}
        {activeSection === 'overview' && (
          <div className="section-reveal">
            {/* Quick stats strip */}
            <div className="quick-stats">
              {topStats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                  <div key={index} className="quick-stat">
                    <div
                      className="quick-stat-icon"
                      style={{ background: stat.bg, color: stat.color }}
                    >
                      <Icon />
                    </div>
                    <div className="quick-stat-info">
                      <span className="quick-stat-label">{stat.label}</span>
                      <span className="quick-stat-value">{stat.value}</span>
                      {stat.subtitle && (
                        <span className="quick-stat-subtitle">
                          {stat.subtitle}
                        </span>
                      )}
                    </div>
                    <FaArrowRight className="quick-stat-arrow" />
                  </div>
                );
              })}
            </div>

            {/* Revenue hero cards */}
            <div className="revenue-overview-cards">
              <div className="revenue-card custom">
                <div className="revenue-card-icon">
                  <FaProjectDiagram />
                </div>
                <div className="revenue-card-info">
                  <span className="revenue-card-label">
                    Custom Projects Revenue
                  </span>
                  <span className="revenue-card-value">
                    {formatCurrency(data.revenue?.custom_projects?.total || 0)}
                  </span>
                  <span className="revenue-card-sub">
                    {formatCurrency(
                      data.revenue?.custom_projects?.monthly || 0,
                    )}{' '}
                    this month
                  </span>
                </div>
                <div className="revenue-card-spark" />
              </div>
              <div className="revenue-card ready">
                <div className="revenue-card-icon">
                  <FaStore />
                </div>
                <div className="revenue-card-info">
                  <span className="revenue-card-label">
                    Ready-Made Revenue
                  </span>
                  <span className="revenue-card-value">
                    {formatCurrency(data.revenue?.ready_made?.total || 0)}
                  </span>
                  <span className="revenue-card-sub">
                    {formatCurrency(data.revenue?.ready_made?.monthly || 0)}{' '}
                    this month
                  </span>
                </div>
                <div className="revenue-card-spark" />
              </div>
              <div className="revenue-card total">
                <div className="revenue-card-icon">
                  <FaDollarSign />
                </div>
                <div className="revenue-card-info">
                  <span className="revenue-card-label">
                    Total Platform Revenue
                  </span>
                  <span className="revenue-card-value">
                    {formatCurrency(data.revenue?.platform?.total || 0)}
                  </span>
                  <span className="revenue-card-sub">
                    {formatCurrency(data.revenue?.platform?.today || 0)} today
                  </span>
                </div>
                <div className="revenue-card-spark" />
              </div>
            </div>

            {/* Revenue charts */}
            <div className="charts-row">
              <div className="chart-card">
                <div className="chart-header">
                  <h3>
                    <FaDollarSign className="chart-icon" /> Revenue Breakdown
                  </h3>
                  <span className="chart-subtitle">
                    Platform revenue per stream
                  </span>
                </div>
                <div className="chart-container">
                  <Bar
                    data={revenueChartData}
                    options={revenueChartOptions}
                  />
                </div>
              </div>

              <div className="chart-card">
                <div className="chart-header">
                  <h3>
                    <FaProjectDiagram className="chart-icon" /> Project Status
                  </h3>
                  <span className="chart-subtitle">
                    Distribution by status
                  </span>
                </div>
                <div className="chart-container doughnut-container">
                  <Doughnut
                    data={projectStatusData}
                    options={doughnutOptions}
                  />
                </div>
              </div>
            </div>

            <div className="charts-row">
              <div className="chart-card wide">
                <div className="chart-header">
                  <h3>
                    <FaChartLine className="chart-icon" /> Monthly Revenue
                    Trend
                  </h3>
                  <span className="chart-subtitle">
                    Performance over the last 12 months
                  </span>
                </div>
                <div className="chart-container tall">
                  <Line data={monthlyRevenueData} options={lineOptions} />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ============ COMMISSIONS ============ */}
        {activeSection === 'commissions' && (
          <div className="section-reveal">
            <div className="panel-header">
              <div>
                <h2>
                  <FaPercent className="panel-icon" /> Commission Overview
                </h2>
                <p>Artiza's earnings from platform commissions</p>
              </div>
              <span className="status-indicator online">
                {formatCurrency(
                  data.commissions?.platform?.total_commission || 0,
                )}{' '}
                total
              </span>
            </div>

            <div className="commission-metrics-grid">
              {commissionMetrics.map((metric, index) => {
                const Icon = metric.icon;
                return (
                  <div key={index} className="commission-metric">
                    <div
                      className="commission-metric-icon"
                      style={{
                        background: 'rgba(103, 50, 0, 0.08)',
                        color: metric.color,
                      }}
                    >
                      <Icon />
                    </div>
                    <div className="commission-metric-info">
                      <span className="commission-metric-label">
                        {metric.label}
                      </span>
                      <span className="commission-metric-value">
                        {metric.value}
                      </span>
                      {metric.sub && (
                        <span className="commission-metric-sub">
                          {metric.sub}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="charts-row">
              <div className="chart-card">
                <div className="chart-header">
                  <h3>
                    <FaMoneyBillWave className="chart-icon" /> Commission
                    Breakdown
                  </h3>
                  <span className="chart-subtitle">By revenue stream</span>
                </div>
                <div className="chart-container">
                  <Bar
                    data={commissionChartData}
                    options={commissionChartOptions}
                  />
                </div>
              </div>

              <div className="chart-card">
                <div className="chart-header">
                  <h3>
                    <FaChartLine className="chart-icon" /> Monthly Commission
                    Trend
                  </h3>
                  <span className="chart-subtitle">Growth over time</span>
                </div>
                <div className="chart-container">
                  <Line
                    data={monthlyCommissionData}
                    options={commissionLineOptions}
                  />
                </div>
              </div>
            </div>

            <div className="charts-row equal">
              <div className="chart-card">
                <div className="chart-header">
                  <h3>
                    <FaProjectDiagram className="chart-icon" /> Custom
                    Projects
                  </h3>
                  <span className="chart-subtitle">
                    Total:{' '}
                    {formatCurrency(
                      data.commissions?.custom_projects?.total_commission ||
                        0,
                    )}
                  </span>
                </div>
                <div className="chart-container doughnut-container">
                  <Doughnut
                    data={customCommissionStatusData}
                    options={commissionDoughnutOptions}
                  />
                </div>
              </div>

              <div className="chart-card">
                <div className="chart-header">
                  <h3>
                    <FaStore className="chart-icon" /> Ready-Made
                  </h3>
                  <span className="chart-subtitle">
                    Total:{' '}
                    {formatCurrency(
                      data.commissions?.ready_made?.total_commission || 0,
                    )}
                  </span>
                </div>
                <div className="chart-container doughnut-container">
                  <Doughnut
                    data={readyMadeCommissionStatusData}
                    options={commissionDoughnutOptions}
                  />
                </div>
              </div>
            </div>

            {data.commissions?.custom_projects?.top_artisans?.length > 0 && (
              <div className="top-commission-artisans">
                <div className="panel-header tight">
                  <h3>
                    <FaTrophy className="panel-icon" /> Top Artisans by
                    Commission
                  </h3>
                </div>
                <div className="artisans-list">
                  {data.commissions.custom_projects.top_artisans
                    .slice(0, 5)
                    .map((artisan, index) => (
                      <div key={index} className="artisan-item">
                        <div className="artisan-rank">{index + 1}</div>
                        <div className="artisan-avatar">
                          {artisan.artisan__full_name?.charAt(0) || 'A'}
                        </div>
                        <div className="artisan-info">
                          <h4>{artisan.artisan__full_name || 'Unknown'}</h4>
                          <p>{artisan.artisan__email}</p>
                        </div>
                        <div className="artisan-stats">
                          <span className="stat-badge">
                            {artisan.count} projects
                          </span>
                        </div>
                        <div className="artisan-rate">
                          <span className="rate-value">
                            {formatCurrency(artisan.total_commission)}
                          </span>
                          <span className="rate-label">commission</span>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ============ REVENUE ============ */}
        {activeSection === 'revenue' && (
          <div className="section-reveal">
            <div className="panel-header">
              <div>
                <h2>
                  <FaDollarSign className="panel-icon" /> Revenue Overview
                </h2>
                <p>Where the platform's revenue comes from</p>
              </div>
            </div>

            <div className="revenue-overview-cards">
              <div className="revenue-card custom">
                <div className="revenue-card-icon">
                  <FaProjectDiagram />
                </div>
                <div className="revenue-card-info">
                  <span className="revenue-card-label">
                    Custom Projects Revenue
                  </span>
                  <span className="revenue-card-value">
                    {formatCurrency(data.revenue?.custom_projects?.total || 0)}
                  </span>
                  <span className="revenue-card-sub">
                    {formatCurrency(
                      data.revenue?.custom_projects?.monthly || 0,
                    )}{' '}
                    this month
                  </span>
                </div>
                <div className="revenue-card-spark" />
              </div>

              <div className="revenue-card ready">
                <div className="revenue-card-icon">
                  <FaStore />
                </div>
                <div className="revenue-card-info">
                  <span className="revenue-card-label">
                    Ready-Made Revenue
                  </span>
                  <span className="revenue-card-value">
                    {formatCurrency(data.revenue?.ready_made?.total || 0)}
                  </span>
                  <span className="revenue-card-sub">
                    {formatCurrency(data.revenue?.ready_made?.monthly || 0)}{' '}
                    this month
                  </span>
                </div>
                <div className="revenue-card-spark" />
              </div>

              <div className="revenue-card total">
                <div className="revenue-card-icon">
                  <FaDollarSign />
                </div>
                <div className="revenue-card-info">
                  <span className="revenue-card-label">
                    Total Platform Revenue
                  </span>
                  <span className="revenue-card-value">
                    {formatCurrency(data.revenue?.platform?.total || 0)}
                  </span>
                  <span className="revenue-card-sub">
                    {formatCurrency(data.revenue?.platform?.today || 0)} today
                  </span>
                </div>
                <div className="revenue-card-spark" />
              </div>
            </div>

            <div className="charts-row">
              <div className="chart-card">
                <div className="chart-header">
                  <h3>
                    <FaDollarSign className="chart-icon" /> Revenue Breakdown
                  </h3>
                  <span className="chart-subtitle">
                    Platform revenue per stream
                  </span>
                </div>
                <div className="chart-container">
                  <Bar
                    data={revenueChartData}
                    options={revenueChartOptions}
                  />
                </div>
              </div>

              <div className="chart-card">
                <div className="chart-header">
                  <h3>
                    <FaProjectDiagram className="chart-icon" /> Project Status
                  </h3>
                  <span className="chart-subtitle">
                    Distribution by status
                  </span>
                </div>
                <div className="chart-container doughnut-container">
                  <Doughnut
                    data={projectStatusData}
                    options={doughnutOptions}
                  />
                </div>
              </div>
            </div>

            <div className="charts-row">
              <div className="chart-card wide">
                <div className="chart-header">
                  <h3>
                    <FaChartLine className="chart-icon" /> Monthly Revenue
                    Trend
                  </h3>
                  <span className="chart-subtitle">
                    Performance over the last 12 months
                  </span>
                </div>
                <div className="chart-container tall">
                  <Line data={monthlyRevenueData} options={lineOptions} />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ============ PAYMENTS ============ */}
        {activeSection === 'payments' && (
          <div className="section-reveal">
            <div className="panel-header">
              <div>
                <h2>
                  <FaWallet className="panel-icon" /> Payments &amp; Orders
                </h2>
                <p>Payment health across custom and ready-made</p>
              </div>
            </div>

            <div className="charts-row equal">
              <div className="chart-card">
                <div className="chart-header">
                  <h3>
                    <FaWallet className="chart-icon" /> Payment Status
                  </h3>
                  <span className="chart-subtitle">Custom projects</span>
                </div>
                <div className="chart-container doughnut-container">
                  <Doughnut
                    data={paymentStatusData}
                    options={paymentDoughnutOptions}
                  />
                </div>
              </div>

              <div className="chart-card">
                <div className="chart-header">
                  <h3>
                    <FaShoppingCart className="chart-icon" /> Checkout Status
                  </h3>
                  <span className="chart-subtitle">Ready-made orders</span>
                </div>
                <div className="chart-container doughnut-container">
                  <Doughnut
                    data={checkoutStatusData}
                    options={paymentDoughnutOptions}
                  />
                </div>
              </div>
            </div>

            {hasPaymentData && (
              <div className="charts-row">
                <div className="chart-card wide">
                  <div className="chart-header">
                    <h3>
                      <FaCreditCard className="chart-icon" /> Payment Type
                      Breakdown
                    </h3>
                    <span className="chart-subtitle">
                      Deposit vs Balance payments
                    </span>
                  </div>
                  <div className="chart-container">
                    <Bar
                      data={paymentTypeData}
                      options={paymentTypeOptions}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

   
      </div>
    </>
  );
};

export default withAuth(AdminDashboard, 'admin');